<template>
    <div class="user-avator-dropdown">
        <Dropdown @on-click="handleClick" trigger="click">
            <Avatar v-if="avatorFlg === true" :src="userAvator"/>
            <!--<a href="javascript:void(0)">
                <span class="main-user-name">{{ userName }}</span>
                <Icon :size="12" type="arrow-down-b"></Icon>
            </a>-->
            <Icon v-if="avatorFlg === false" size="24" type="md-person"/>
            <DropdownMenu slot="list">
                <DropdownItem name="myInfo">{{$_t().main.myInfo}}</DropdownItem>
                <DropdownItem name="logout">{{$_t().main.logOut}}</DropdownItem>
            </DropdownMenu>
        </Dropdown>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'user',
    computed: {
        avatorFlg() {
            if (this.$store.state.user.myInfo.avatar == null || this.$store.state.user.myInfo.avatar === '') {
                return false;
            } else {
                return true;
            }
        },
        userAvator() {
            return this.$store.state.user.myInfo.avatar;
        },
        userName() {
            return this.$store.state.user.myInfo.loginName;
        },
    },
    methods: {
        ...mapActions('user', ['handleLogOut']),
        handleClick(name) {
            switch (name) {
                case 'myInfo':
                    this.$router.push({
                        name: 'my_info',
                    });
                    break;
                case 'logout':
                    this.handleLogOut().then(() => {
                        this.$router.push({
                            name: 'login',
                        });
                    });
                    break;
            }
        },
    },
};
</script>
<style lang="less" scoped>
.user {
    &-avator-dropdown {
        display: inline-block;
        height: 32px;
        vertical-align: middle;
        line-height: 10px;
        cursor: pointer;
    }
}
</style>
